import { OrganizationReport, PlotGroupComparison } from './organization';
import { Plot } from './plot';
import { PlotGroup } from './plotGroup';

export type SearchResult = {
  plots: Plot[];
  plot_groups: PlotGroup[];
  comparisons: PlotGroupComparison[];
  reports: OrganizationReport[];
};

/**
 * GET /api/v1/dashboard/organization/{organization_id}/search/
 */
export const GET_ORGANIZATION_SEARCH_PATH = 'dashboard/organization/{organization_id}/search';
export type GetOrganizationSearchRequestPathVariables = { organization_id: string };
export type GetOrganizationSearchRequestQueryParams = {
  query?: string;
};
export type GetOrganizationSearchSuccessDto = SearchResult;
export type GetOrganizationSearchErrorDto = Error;

/**
 * GET /api/v1/dashboard/search/
 */
export const GET_GLOBAL_SEARCH_PATH = 'dashboard/search';
export type GetGlobalSearchRequestPathVariables = undefined;
export type GetGlobalSearchRequestQueryParams = {
  query?: string;
};
export type GetGlobalSearchSuccessDto = SearchResult;
export type GetGlobalSearchErrorDto = Error;
